import { Channel } from './channel';

export const FAILURE = 'Failure';
export const ALARM_OPTION = 'ALARM';

export const LOGIC_OPERATOR = {
    LT: '<',
    GT: '>',
    BOTH: '<>',
    NONE: '',
} as const;

export type LogicOperator = (typeof LOGIC_OPERATOR)[keyof typeof LOGIC_OPERATOR];

export class ElementConditionLogic {
    id: string;
    elementId: string;
    conditionId: string;
    matrixChannelId: string;
    index: number;
    analogOperator: LogicOperator;
    analogValue: string;
    digitalString: string;
    setToAlarm: boolean;
}

export type ElementConditionLogicViewData = {
    id: string;
    elementId: string;
    conditionId: string;
    matrixChannelId: string;
    index: number;
    analogOperator: LogicOperator;
    analogValue: string;
    digitalString: string;
    setToAlarm: boolean;
    isError: boolean;
    channel: Channel;
};
